import {
  JSXElementConstructor,
  ReactElement,
  ReactNode,
  ReactPortal,
  useState,
} from "react";
import { observer } from "mobx-react";
import {
  CommandCentreVenue,
  InjectableUserState,
  MobileAppBannerType,
  MobileAttractorType,
  MobileBanner,
} from "../types";
import { useColors } from "../provider/colors-provider";
import { userState } from "../state/UserState";

export type Props = {
  screenType:
    | "NOTIFICATION_PREVIEW" // sets app icon, app abbreviation and the notification title/message
    | "MY_CLUB" // background+bottom bar screen
    | "MY_HOME"; // background+bottom bar screen

  myClubPromotions?: MobileAttractorType[];
  myHomeAppBanner?: MobileBanner;

  notificationTitle?: string;
  notificationMessage?: string;
};

type PhonePreviewProps = Props & InjectableUserState;

export const PhonePreview = observer((props: PhonePreviewProps) => {
  const { primary } = useColors();
  const selectedVenue = props?.userState?.selectedVenue;

  function getNotificationPreviewScreen(appIconStyle: {}) {
    return (
      <div className="screen">
        <div className={"mock-ios-time text-white"}>9:41</div>
        <div className={"mock-ios-day text-white"}>Thursday, May 22</div>
        <div className={"mock-ios-notification-container"}>
          <div className={"flex justify-between"} style={{ marginBottom: 8 }}>
            <div className="flex">
              {" "}
              <div className={"mock-ios-appicon"} style={appIconStyle} />
              <div className={"mock-ios-apptitle "}>
                {selectedVenue?.displayName
                  ? selectedVenue?.displayName
                  : "APPNAME"}
              </div>
            </div>
            <div className={"mock-ios-notification-time"}>22m</div>
          </div>
          <div className={"mock-ios-notification-title"}>
            {props.notificationTitle ?? "Notification Title"}
          </div>
          <div className={"mock-ios-notification-body"}>
            {props.notificationMessage ?? "Notification Message"}
          </div>
        </div>
      </div>
    );
  }

  function getMyClubScreen() {
    let promotionViews = props.myClubPromotions?.map(
      (attractor: {
        thumbnailS3Key: string | undefined;
        displayText:
          | string
          | number
          | boolean
          | ReactElement<any, string | JSXElementConstructor<any>>
          | Iterable<ReactNode>
          | ReactPortal
          | null
          | undefined;
      }) => {
        return (
          <div
            key={attractor.thumbnailS3Key}
            style={{
              background: "rgba(0, 0, 0, 0.7)",
              overflow: "hidden",
            }}
          >
            <img
              className="mt-4"
              style={{
                padding: 5,
                borderRadius: 20,
                height: "100%",
                width: "100%",
                objectFit: "cover",
              }}
              src={attractor?.thumbnailS3Key}
            />
            <div
              style={{
                color: "white",
                padding: 12,
                fontSize: 24,
                textAlign: "center",
              }}
            >
              {attractor.displayText}
            </div>
          </div>
        );
      }
    );

    return (
      <div className="screen">
        <div
          style={{
            overflow: "hidden",
            backgroundImage: "url(" + selectedVenue?.backgroundUrl + ")",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            height: "100%",
          }}
        >
          <div style={{ height: "100%", background: "rgba(0, 0, 0, 0.6)" }}>
            <div
              style={{
                fontSize: 34,
                color: "white",
                fontWeight: "bold",
                paddingLeft: 20,
                paddingTop: 56,
                paddingBottom: 16,
              }}
            >
              My Casino
            </div>

            <div
              style={{
                height: "calc(100% - 90px)",
                overflowY: "auto",
                scrollbarWidth: "thin",
                scrollbarColor: "rgba(255, 255, 255, 0.3) transparent",
                position: "relative",
                width: "100%",
                paddingRight: "0",
                marginRight: "0",
              }}
              className="custom-scrollbar-overlay"
            >
              {promotionViews}
            </div>
          </div>
        </div>
      </div>
    );
  }

  function getMyHomeScreen() {
    return (
      <div className="screen">
        <div
          style={{
            overflow: "hidden",
            backgroundImage: "url(" + selectedVenue?.backgroundUrl + ")",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            height: "100%",
          }}
        >
          <div style={{ height: "100%", background: "rgba(0, 0, 0, 0.6)" }}>
            <div style={{ display: "flex", marginTop: "3rem", padding: 6 }}>
              <img
                style={{
                  borderRadius: 8,
                  objectFit: "cover",
                }}
                src={props.myHomeAppBanner?.thumbnailS3Key}
              />
              {/* <div
                style={{
                  height: 48,
                  width: 48,
                  marginTop: 72,
                  marginLeft: 20,
                  backgroundColor: 'white',
                  borderRadius: 8,
                }}
              ></div> */}
            </div>

            <div
              style={{
                fontSize: 26,
                color: "white",
                fontWeight: "bold",
                paddingLeft: 20,
                paddingTop: 40,
                opacity: 0.8,
              }}
            >
              Welcome back
            </div>
            <div
              style={{
                fontSize: 34,
                color: "white",
                fontWeight: "bold",
                paddingLeft: 20,
                paddingTop: 0,
                lineHeight: 1.1,
              }}
            >
              {userState.user?.firstName ?? "John Doe"}{" "}
            </div>
            <div
              className="text-gray-200"
              style={{
                fontSize: 26,
                fontWeight: "bold",
                paddingLeft: 20,
                paddingTop: 0,
              }}
            >
              Member #00001337
            </div>

            <div
              style={{
                background: "rgba(0, 0, 0, 0.7)",
                overflow: "hidden",
                marginTop: 60,
                borderRadius: 20,
                height: "100%",
              }}
            >
              <div
                style={{
                  fontSize: 34,
                  color: primary,
                  fontWeight: "bold",
                  paddingTop: 16,
                  textAlign: "center",
                }}
              >
                GOLD TIER
              </div>
              <div
                style={{
                  backgroundColor: primary,
                  height: 6,
                  borderRadius: 10,
                  margin: "8px 16px",
                }}
              />
            </div>
          </div>
        </div>

        <div style={{ backgroundColor: "white", height: "10%" }}></div>
      </div>
    );
  }

  let screenView;
  let screenStyle: {} = { zoom: 0.6 };
  if (props.screenType == "NOTIFICATION_PREVIEW") {
    let appIconStyle;
    if (selectedVenue?.iconUrl != undefined) {
      appIconStyle = { backgroundImage: "url(" + selectedVenue?.iconUrl + ")" };
    } else {
      appIconStyle = { backgroundColor: "blue" };
    }

    screenStyle = { zoom: 0.7, top: 80, marginTop: -80, height: 740 };
    screenView = getNotificationPreviewScreen(appIconStyle);
  } else if (props.screenType == "MY_CLUB") {
    screenView = getMyClubScreen();
  } else if (props.screenType == "MY_HOME") {
    screenStyle = { zoom: 0.7, top: 90, marginTop: -80, height: 740 };
    screenView = getMyHomeScreen();
  }

  return (
    <div className={"flex-cen-stack"} style={{}}>
      <div className="marvel-device iphone-x" style={screenStyle}>
        <div className="notch">
          <div className="camera"></div>
          <div className="speaker"></div>
        </div>
        <div className="top-bar"></div>
        <div className="sleep"></div>
        <div className="bottom-bar"></div>
        <div className="volume"></div>
        <div className="overflow">
          <div className="shadow shadow--tr"></div>
          <div className="shadow shadow--tl"></div>
          <div className="shadow shadow--br"></div>
          <div className="shadow shadow--bl"></div>
        </div>
        <div className="inner-shadow"></div>

        {screenView}
      </div>
    </div>
  );
});
